import { render, staticRenderFns } from "./BaseDropdownMenu.vue?vue&type=template&id=bc3a5086&"
import script from "./BaseDropdownMenu.vue?vue&type=script&lang=ts&"
export * from "./BaseDropdownMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports